module.exports = __webpack_public_path__ + "static/NMR-93fe02c2922458283b7361f4acb71365.svg";